/**
 * The current path and query with `names` removed — for dropping a consumed
 * deep-link param via navigate(…, { replace: true }).
 *
 * @param {{ pathname: string, search: string }} location
 * @param {string[]} names query params to drop
 * @returns {string}
 */
export const pathWithoutParams = (location, names) => {
  const params = new URLSearchParams(location.search);
  names.forEach((name) => params.delete(name));
  const query = params.toString();
  return query ? `${location.pathname}?${query}` : location.pathname;
};
